import { combineReducers } from 'redux';
import { limitOrderInputFormReducer } from 'state/secondaryMarket/limit-order/form/input/inputForm.reducer';
import { limitOrderOriginalFormReducer } from 'state/secondaryMarket/limit-order/form/original/original.reducer';

import type { SecondaryMarketLimitOrderFormData } from './form.model';

export const formReducer = combineReducers<SecondaryMarketLimitOrderFormData>({
  input: limitOrderInputFormReducer,
  original: limitOrderOriginalFormReducer,
});
